/**
 * 任务来源
 */
export enum PickupSourceEnum {
    APPOINTMENT_LIST = 'APPOINTMENT_LIST',// 预约单列表
    APPOINTMENT_MAP = 'APPOINTMENT_MAP',// 预约单地图
    STANDING_PICKUP = 'STANDING_PICKUP'//任务计划
}


